import { render, staticRenderFns } from "./sport-membership-emails-form.vue?vue&type=template&id=48dd14d5"
import script from "./sport-membership-emails-form.vue?vue&type=script&lang=js"
export * from "./sport-membership-emails-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports